import ReactDOM from "react-dom";
import App from "./App";
// import "antd/dist/antd.css"
import "./antd.scss";
import "antd/es/button/style/index.css"
import "antd/es/modal/style/index.css"
import "antd/es/typography/style/index.css"
import React from "react";
import "./index.scss";
import {isDev} from "../../util/devWarning";

declare global {
    export interface Window {
        gameBaseInfo: any;
        setupPlayGame: any;
    }
}


const params = new URLSearchParams(window.location.search);

const ad = params.get("ad");
// if (isDev  || (gameId === "000054" && ad === 'vip')) {
function setupPlayGame() {
    const game = window.gameBaseInfo;
    if (!game) {
        console.log("setup play game failure, game required");
        return;
    }
    console.log("setup play game")
    ReactDOM.render(
        <App gameId={game.gameId}/>,
        document.getElementById('setup')
    );
}

if (isDev) {
    setupPlayGame();
} else {
    if ((ad === 'vip')) {
        window.setupPlayGame = setupPlayGame;
    }
}


